import {IntegrationsPageLayout} from '../../../_gori/layout/components/IntegrationsPagesLayout'
import {SeoHead} from '../../modules/seo'

export function ShopifyIntegration() {
  return (
    <>
      <SeoHead />
      <IntegrationsPageLayout
        pageClass='shopify-integration'
        integrationLogo='/media/gori/integrations/shopify/shopify-logo.svg'
        integrationLogoAlt='shopify-logo'
        integrateImg='/media/gori/integrations/shopify/integrate.webp'
        card1Copy='SHOPIFY_CARD_1'
        card2Copy='SHOPIFY_CARD_2'
        card3Copy='SHOPIFY_CARD_3'
        card4Copy='SHOPIFY_CARD_4'
        store='Shopify'
      />
    </>
  )
}
